import videojs from 'video.js';

function isObject(obj) {
  return typeof obj === 'object';
}

function isIFrame() {
  return window.parent && window.location != window.parent.location;
}

function xhr(url, params, callback) {
 
  var options = params || {};
  if (!url) return;

  var cb = callback || function() {};

  if (options.method.toUpperCase() == "POST") {
    options.headers = options.headers || {},
    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    options.data = utils.paramsToStr(options.data);
  } else {
    url = utils.addUrlParam(url, options.data);
  }

  videojs.xhr(url, options, cb);
}

function paramsToStr(obj) {
  var res = '';

 if (utils.isObject(obj)) {
    res = '';
    for (let i in obj){
      if (res) res += '&';
      res += i + '=' + obj[i];
    }
  }

  return res;
}

function addUrlParam(url, param, val) {
    if (utils.isObject(param)) {
      let result = url;
      for (let i in param) {
        result = utils.addUrlParam(result, i, param[i]);
      }
      return result;
    } else {
      if (url.indexOf(param + '=') != -1) {
        return url.replace(new RegExp(param + '=[^&]*'), param + '=' + val);
      } else {
        let sign = url.indexOf('?') != -1 ? (url.endsWith('?') ? '' : '&') : '?';
        return url + sign + param + '=' + val;
      }
    }
}


var utils = {
  xhr: xhr,
  paramsToStr: paramsToStr,
  addUrlParam: addUrlParam,
  isObject: isObject,
  isIFrame: isIFrame
};

export default utils;